import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormField from '../common/FormField';
import Alert from '../common/Alert';
import { validateEmail, validateMobile } from '../../utils/validators';
import './InvitationSend.css';

const InvitationSend = ({ onSend, isSending, propertyAddress }) => {
  const [formData, setFormData] = useState({ email: '', mobile: '', expiryDays: 7 });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    errs.email = validateEmail(formData.email);
    if (formData.mobile) {
      errs.mobile = validateMobile(formData.mobile);
    }
    
    // Clean nulls
    Object.keys(errs).forEach(k => errs[k] == null && delete errs[k]);
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSend(formData);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
  };

  return (
    <div className="invitation-send card">
      <div className="card-header">
        <h2>Send Application Invitation</h2>
      </div>
      <div className="card-body">
        <p className="body-text" style={{ marginBottom: '16px' }}>
          Invite a prospective tenant to apply for <strong>{propertyAddress}</strong>. They will receive a secure link to provide their details and grant background check consents.
        </p>

        <div className="invitation-send__layout">
          <form className="invitation-send__form" onSubmit={handleSubmit}>
            <FormField
              label="Applicant Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
              required
            />
            <FormField
              label="Applicant Mobile (Optional)"
              name="mobile"
              type="tel"
              value={formData.mobile}
              onChange={handleChange}
              error={errors.mobile}
              placeholder="0821234567"
              helperText="If provided, an SMS invite will also be sent."
            />
            <FormField
              label="Link Expiry (Days)"
              name="expiryDays"
              type="number"
              min="1"
              max="30"
              value={formData.expiryDays}
              onChange={handleChange}
              required
            />
            
            <button type="submit" className="btn-primary" disabled={isSending}>
              {isSending ? 'Sending Invite...' : 'Send Invitation'}
            </button>
          </form>

          <div className="invitation-send__preview">
            <h3>Email Preview</h3>
            <div className="preview-box">
              <p><strong>Subject:</strong> Invitation to apply for tenancy at {propertyAddress}</p>
              <hr />
              <p>Hello,</p>
              <p>You have been invited to submit a secure rental application for {propertyAddress}.</p>
              <p>Please click the link below to provide your details and complete the necessary background check consents.</p>
              <div className="preview-btn">Start Application</div>
              <p><small>This link will expire in {formData.expiryDays} days.</small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InvitationSend.propTypes = {
  onSend: PropTypes.func.isRequired,
  isSending: PropTypes.bool,
  propertyAddress: PropTypes.string.isRequired
};

export default InvitationSend;
